import { localStorageStore } from '@skeletonlabs/skeleton';
import { writable, type Writable } from 'svelte/store';
import type { AdminProductFilters, Cart, Checkout } from './types';
import { defaultAdminProductFilters } from './utils/constants';

export const cart: Writable<Cart> = localStorageStore('cart', []);

export const adminProductFilters = writable<AdminProductFilters>(defaultAdminProductFilters);

export const deviceWidth = writable<number>(0);

export const checkout = writable<Checkout>({
	address_id: undefined,
	card_id: undefined,
	shipping_opt: undefined,
	use_new_card: false
});
